// Base JS file that get's loaded on every B2B page
// Used in `jinja2/b2b/b2b_base.html`

// Import web components so they can be used in the templates
import 'chipta-libs/components/font-awesome.js';
import 'chipta-libs/components/language-switch.js';
import 'components/contact-form.js';
import 'components/icon/arrow-right.js';
import 'components/icon/badge.js';
import 'components/icon/chipta-logo.js';
import 'components/icon/cross.js';
import 'components/icon/hamburger.js';
import 'components/layout/chipta-logo-background.js';
import 'components/layout/concave.js';
import 'components/layout/wave.js';
import 'components/menu.js';
